// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4wybp","index":"styles_index__3JMwQ"};